import React from 'react';
import './CustomModel.css'; // Import the CSS here

const CustomModel = ({ isOpen, question, onYes, onNo, close }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay-payment">
            <div className="form-modal-payment">
                <h2>
                    {question === 'Request Property' ? (
                        <>
                            Your previous <strong>property request</strong> is still <strong>on hold</strong>. Would you like to continue?
                        </>
                    ) : <>Your previous <strong>Know your property</strong> is still <strong>on hold</strong>. Would you like to continue?</>}
                </h2>

                <div className="modal-buttons">
                    <button
                        onClick={() => {
                            onYes();
                            close();
                        }}
                        className="yes-button"
                    >
                        Yes
                    </button>
                    <button
                        onClick={() => {
                            onNo();
                            close();
                        }}
                        className="no-button"
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomModel;

